<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- This component is only designed to be used in the "Add New" part of "role-schedules.html" -->
<mat-extended-select
	[placeholder]="'Select a role'"
	[option$]="option$"
	[includeFilter]="true"
	[formControl]="internalFormControl"
	[labelPath]="['roleName']"
	[valuePath]="['data']"
	[required]="false"
	[multiSelect]="multiple"
	subScriptSizing="dynamic"
>
</mat-extended-select>
